export const phoneRegex = /(^(\+88|0088|88)?(01){1}[3456789]{1}(\d){8})$/;

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const spaceRegex = /^(?:[^\s]*\s{0,4}[^\s]*)$/;
